/**
 * Zoom level utilities
 */

import { ZOOM_LEVELS, ZOOM_SCALES } from './constants';

// Min and max scale values for continuous zoom
export const MIN_SCALE = 0.05;  // Very zoomed out (year overview)
export const MAX_SCALE = 50;    // Max zoom in (hour-detail level, ~200px per hour)

/**
 * Get next zoom level (in or out) - for discrete zoom
 */
export function getNextZoomLevel(current, direction) {
  const currentIndex = ZOOM_LEVELS.indexOf(current);
  if (currentIndex === -1) return 'day';
  
  if (direction === 'in') {
    return currentIndex > 0 ? ZOOM_LEVELS[currentIndex - 1] : current;
  } else {
    return currentIndex < ZOOM_LEVELS.length - 1 ? ZOOM_LEVELS[currentIndex + 1] : current;
  }
}

/**
 * Get the timeline width multiplier for a zoom level
 */
export function getTimelineScale(zoomLevel) {
  return ZOOM_SCALES[zoomLevel] ?? 1;
}

/**
 * Get the appropriate zoom level name for a given scale (for column generation)
 * 
 * Thresholds determine when the timeline switches display modes:
 * - Higher scales = more zoomed in (hours, days)
 * - Lower scales = more zoomed out (weeks, months, years)
 */
export function getZoomLevelForScale(scale) {
  if (scale >= 36) return 'hour-detail';
  if (scale >= 12) return 'hour';
  if (scale >= 4) return 'day-detail';
  if (scale >= 1.5) return 'day';
  if (scale >= 0.5) return 'week';      // Weeks (top: months)
  if (scale >= 0.15) return 'month';    // Months (top: years)
  if (scale >= 0.08) return 'quarter';  // Quarters (top: years)
  return 'year';
}

/**
 * Apply zoom factor to current scale
 */
export function applyZoomDelta(currentScale, delta) {
  // Multiplicative zoom - feels more natural
  const factor = 1 - delta * 0.002; // Small factor for smooth zooming
  const newScale = currentScale * factor;
  return Math.max(MIN_SCALE, Math.min(MAX_SCALE, newScale));
}
